export const URL_TRIVIA = process.env.NEXT_PUBLIC_TRIVIA_ORIGIN;
export const URL_TRIVIA_IMAGE = "https://images.hallow.app/home/web_trivia.png";
